import { DetailOvertimeComponent } from './details-lembur.component';
export default DetailOvertimeComponent;
